export type VimeoMessage = {
  event?: string
  method?: string
  value?: unknown
}

/**
 * Normalizes a message posted by the Vimeo player iframe.
 *
 * The player posts structured-clone objects, but older versions posted JSON
 * strings - accept both and return null for anything unusable so callers don't
 * need their own try/catch.
 */
export const parseVimeoMessage = (data: unknown): VimeoMessage | null => {
  if (typeof data === "string") {
    try {
      return JSON.parse(data) as VimeoMessage
    } catch {
      return null
    }
  }

  if (typeof data === "object" && data !== null) return data as VimeoMessage

  return null
}
